import styled from 'styled-components';
import { SectionTitle } from './sectionTitle';

export const SectionDescription = styled.div`
    font-weight: 400;
    color: #455a64;
    font-size: 13px;
    margin-top: 0px;
    font-family: ${(props) => props.theme.app.font};
    text-align: left;

    margin-bottom: 16px;

    ${SectionTitle} + & {
        padding-top: 4px;
    }
`;
